import { Link } from "react-router-dom";
import { UserPlus } from "lucide-react";
import { useAuth } from "../lib/auth";
import { useContent } from "../lib/content";

export default function SaveChartCta({ form }) {
  const { user } = useAuth();
  const { t } = useContent();
  const birth = { birth_date: form.birth_date, birth_time: form.birth_time, birth_place: form.birth_place };
  return (
    <div data-testid="save-chart-cta" className="mb-10 p-8 border border-white/10 bg-white/[0.02]">
      <p className="overline mb-2">{t("plat_save_overline")}</p>
      <p className="text-white font-display text-2xl mb-2">{t("plat_save_title")}</p>
      <p className="text-zinc-400 text-sm mb-5">{t("plat_save_body")}</p>
      {user ? (
        <Link to="/mi-panel" data-testid="save-chart-panel" className="btn-ghost inline-flex items-center gap-2 text-sm">
          Ir a mi panel →
        </Link>
      ) : (
        <Link to="/registro" state={{ name: form.name, email: form.email, birth }} data-testid="save-chart-register"
          className="btn-lilac inline-flex items-center gap-2">
          <UserPlus size={16} /> {t("plat_save_cta")}
        </Link>
      )}
    </div>
  );
}
